var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.8/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"is_bot"),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":6,"column":12},"end":{"line":10,"column":19}}})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "            <i class=\"zulip-icon zulip-icon-bot\" aria-hidden=\"true\"></i>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var alias1=container.strict, alias2=container.lambda, alias3=container.escapeExpression;

  return "            <span class=\""
    + alias3(alias2(alias1(depth0, "user_circle_class", {"start":{"line":9,"column":27},"end":{"line":9,"column":44}} ), depth0))
    + " user_circle popover_user_presence tippy-zulip-tooltip hidden-for-spectators\" data-tippy-content=\""
    + alias3(alias2(alias1(depth0, "user_last_seen_time_status", {"start":{"line":9,"column":146},"end":{"line":9,"column":172}} ), depth0))
    + "\"></span>\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "        <span class=\"user_info_popover_action_buttons\">\n            <a class=\"user_info_popover_manage_menu_btn\" role=\"button\" tabindex=\"0\" aria-haspopup=\"true\">\n                <i class=\"popover_action_icon zulip-icon zulip-icon-ellipsis-v-solid\" aria-hidden=\"true\"></i>\n            </a>\n        </span>\n";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"user_email"),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":8},"end":{"line":31,"column":15}}})) != null ? stack1 : "");
},"9":function(container,depth0,helpers,partials,data) {
    var alias1=container.strict, alias2=container.lambda, alias3=container.escapeExpression;

  return "        <div>\n            <li class=\"user_popover_email\">\n                <i class=\"fa fa-clone hide_copy_icon\" data-clipboard-text=\""
    + alias3(alias2(alias1(depth0, "user_email", {"start":{"line":27,"column":78},"end":{"line":27,"column":88}} ), depth0))
    + "\"></i>\n                "
    + alias3(alias2(alias1(depth0, "user_email", {"start":{"line":28,"column":19},"end":{"line":28,"column":29}} ), depth0))
    + "\n            </li>\n        </div>\n";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li class=\"user_popover_email half-opacity italic\">"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"is_bot"),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.program(14, data, 0),"data":data,"loc":{"start":{"line":33,"column":59},"end":{"line":33,"column":167}}})) != null ? stack1 : "")
    + "</li>\n";
},"12":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"This bot has been deactivated.",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":33,"column":73},"end":{"line":33,"column":112}}}));
},"14":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"This user has been deactivated.",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":33,"column":120},"end":{"line":33,"column":160}}}));
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"bot_owner"),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.program(19, data, 0),"data":data,"loc":{"start":{"line":38,"column":8},"end":{"line":48,"column":15}}})) != null ? stack1 : "");
},"17":function(container,depth0,helpers,partials,data) {
    var alias1=container.strict, alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li class=\"bot_owner\" data-tippy-content=\""
    + alias3(alias2(alias1(lookupProperty(depth0,"bot_owner"), "full_name", {"start":{"line":39,"column":57},"end":{"line":39,"column":76}} ), depth0))
    + "\">"
    + alias3(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"Bot owner",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":39,"column":81},"end":{"line":39,"column":99}}}))
    + ":\n                <span class=\"bot-owner-name view_user_profile\" data-user-id='"
    + alias3(alias2(alias1(lookupProperty(depth0,"bot_owner"), "user_id", {"start":{"line":40,"column":80},"end":{"line":40,"column":97}} ), depth0))
    + "'>\n                    "
    + alias3(alias2(alias1(lookupProperty(depth0,"bot_owner"), "full_name", {"start":{"line":41,"column":22},"end":{"line":41,"column":41}} ), depth0))
    + "\n                </span>\n            </li>\n";
},"19":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"is_system_bot"),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.program(22, data, 0),"data":data,"loc":{"start":{"line":44,"column":8},"end":{"line":48,"column":8}}})) != null ? stack1 : "");
},"20":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>"
    + container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"System bot",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":45,"column":16},"end":{"line":45,"column":35}}}))
    + "</li>\n";
},"22":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>"
    + container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"Bot",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":47,"column":16},"end":{"line":47,"column":28}}}))
    + "</li>\n        ";
},"24":function(container,depth0,helpers,partials,data) {
    return "        <li>"
    + container.escapeExpression(container.lambda(container.strict(depth0, "user_type", {"start":{"line":50,"column":15},"end":{"line":50,"column":24}} ), depth0))
    + "</li>\n";
},"26":function(container,depth0,helpers,partials,data) {
    return "        <hr />\n";
},"28":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li class=\"hidden-for-spectators local_time\">"
    + container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"{user_time} local time",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":61,"column":53},"end":{"line":61,"column":84}}}))
    + "</li>\n";
},"30":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li class=\"user_info_status_text\">\n            <span id=\"status_message\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(depth0,"status_emoji_info"),{"name":"if","hash":{},"fn":container.program(31, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":67,"column":16},"end":{"line":75,"column":23}}})) != null ? stack1 : "")
    + "                <span class=\"status_text\">\n                    "
    + container.escapeExpression(container.lambda(container.strict(depth0, "status_text", {"start":{"line":77,"column":22},"end":{"line":77,"column":33}} ), depth0))
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(depth0,"is_me"),{"name":"if","hash":{},"fn":container.program(39, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":78,"column":20},"end":{"line":80,"column":27}}})) != null ? stack1 : "")
    + "                </span>\n            </span>\n        </li>\n";
},"31":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(lookupProperty(depth0,"status_emoji_info"),"emoji_alt_code"),{"name":"if","hash":{},"fn":container.program(32, data, 0),"inverse":container.program(34, data, 0),"data":data,"loc":{"start":{"line":68,"column":20},"end":{"line":74,"column":27}}})) != null ? stack1 : "");
},"32":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <div class=\"emoji_alt_code\">&nbsp;:"
    + container.escapeExpression(container.lambda(container.strict(lookupProperty(depth0,"status_emoji_info"), "emoji_name", {"start":{"line":69,"column":61},"end":{"line":69,"column":89}} ), depth0))
    + ":</div>\n";
},"34":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(lookupProperty(depth0,"status_emoji_info"),"url"),{"name":"if","hash":{},"fn":container.program(35, data, 0),"inverse":container.program(37, data, 0),"data":data,"loc":{"start":{"line":70,"column":20},"end":{"line":74,"column":20}}})) != null ? stack1 : "");
},"35":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <img src=\""
    + container.escapeExpression(container.lambda(container.strict(lookupProperty(depth0,"status_emoji_info"), "url", {"start":{"line":71,"column":36},"end":{"line":71,"column":57}} ), depth0))
    + "\" class=\"emoji status-emoji\" />\n";
},"37":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <div class=\"emoji status-emoji emoji-"
    + container.escapeExpression(container.lambda(container.strict(lookupProperty(depth0,"status_emoji_info"), "emoji_code", {"start":{"line":73,"column":63},"end":{"line":73,"column":91}} ), depth0))
    + "\"></div>\n                    ";
},"39":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <span class=\"clear_status_button\">(<a tabindex=\"0\" class=\"clear_status\">"
    + container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"clear",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":79,"column":92},"end":{"line":79,"column":106}}}))
    + "</a>)</span>\n";
},"41":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li>\n            <a tabindex=\"0\" class=\"update_status_text\">\n                <i class=\"fa fa-comments\" aria-hidden=\"true\"></i>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(depth0,"status_text"),{"name":"if","hash":{},"fn":container.program(42, data, 0),"inverse":container.program(44, data, 0),"data":data,"loc":{"start":{"line":90,"column":16},"end":{"line":94,"column":23}}})) != null ? stack1 : "")
    + "            </a>\n        </li>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(depth0,"invisible_mode"),{"name":"if","hash":{},"fn":container.program(46, data, 0),"inverse":container.program(48, data, 0),"data":data,"loc":{"start":{"line":97,"column":8},"end":{"line":109,"column":15}}})) != null ? stack1 : "");
},"42":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    "
    + container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"Edit status",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":91,"column":20},"end":{"line":91,"column":40}}}))
    + "\n";
},"44":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    "
    + container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"Set a status",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":93,"column":20},"end":{"line":93,"column":41}}}))
    + "\n";
},"46":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li>\n            <a tabindex=\"0\" class=\"invisible_mode_turn_off\">\n                <i class=\"fa fa-circle-o\" aria-hidden=\"true\"></i> "
    + container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"Turn off invisible mode",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":100,"column":66},"end":{"line":100,"column":98}}}))
    + "\n            </a>\n        </li>\n";
},"48":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li>\n            <a tabindex=\"0\" class=\"invisible_mode_turn_on\">\n                <i class=\"fa fa-circle-o\" aria-hidden=\"true\"></i> "
    + container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"Go invisible",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":106,"column":66},"end":{"line":106,"column":87}}}))
    + "\n            </a>\n        </li>\n";
},"50":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.strict, alias3=container.lambda, alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <hr />\n        <li>\n            <a tabindex=\"0\" class=\"view_full_user_profile\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(depth0,"is_me"),{"name":"if","hash":{},"fn":container.program(51, data, 0),"inverse":container.program(53, data, 0),"data":data,"loc":{"start":{"line":117,"column":16},"end":{"line":121,"column":23}}})) != null ? stack1 : "")
    + "            </a>\n        </li>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(depth0,"can_send_private_message"),{"name":"if","hash":{},"fn":container.program(55, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":124,"column":8},"end":{"line":130,"column":15}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,lookupProperty(depth0,"is_me"),{"name":"unless","hash":{},"fn":container.program(58, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":131,"column":8},"end":{"line":147,"column":19}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(depth0,"is_me"),{"name":"if","hash":{},"fn":container.program(68, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":148,"column":8},"end":{"line":154,"column":15}}})) != null ? stack1 : "")
    + "        <hr />\n        <li>\n            <a href=\""
    + alias4(alias3(alias2(depth0, "pm_with_url", {"start":{"line":157,"column":24},"end":{"line":157,"column":35}} ), depth0))
    + "\" class=\"narrow_to_private_messages\">\n                <i class=\"fa fa-envelope\" aria-hidden=\"true\"></i>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(depth0,"is_me"),{"name":"if","hash":{},"fn":container.program(70, data, 0),"inverse":container.program(72, data, 0),"data":data,"loc":{"start":{"line":159,"column":16},"end":{"line":163,"column":23}}})) != null ? stack1 : "")
    + "            </a>\n        </li>\n        <li>\n            <a href=\""
    + alias4(alias3(alias2(depth0, "sent_by_url", {"start":{"line":167,"column":24},"end":{"line":167,"column":35}} ), depth0))
    + "\" class=\"narrow_to_messages_sent\">\n                <i class=\"fa fa-paper-plane\" aria-hidden=\"true\"></i> "
    + alias4(lookupProperty(helpers,"t").call(alias1,"View messages sent",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":168,"column":69},"end":{"line":168,"column":96}}}))
    + "\n            </a>\n        </li>\n";
},"51":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <i class=\"fa fa-user\" aria-hidden=\"true\"></i> "
    + container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"View your profile",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":118,"column":66},"end":{"line":118,"column":92}}}))
    + "\n";
},"53":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <i class=\"fa fa-user\" aria-hidden=\"true\"></i> "
    + container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"View profile",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":120,"column":66},"end":{"line":120,"column":87}}}))
    + "\n";
},"55":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <li>\n                <a tabindex=\"0\" class=\""
    + alias1(container.lambda(container.strict(depth0, "private_message_class", {"start":{"line":126,"column":42},"end":{"line":126,"column":63}} ), depth0))
    + "\">\n                    <i class=\"fa fa-comment\" aria-hidden=\"true\"></i> "
    + alias1(lookupProperty(helpers,"t").call(alias2,"Send direct message",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":127,"column":69},"end":{"line":127,"column":97}}}))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias2,lookupProperty(depth0,"is_sender_popover"),{"name":"if","hash":{},"fn":container.program(56, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":127,"column":98},"end":{"line":127,"column":166}}})) != null ? stack1 : "")
    + "\n                </a>\n            </li>\n";
},"56":function(container,depth0,helpers,partials,data) {
    return "<span class=\"hotkey-hint\">(R)</span>";
},"58":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"has_message_context"),{"name":"if","hash":{},"fn":container.program(59, data, 0),"inverse":container.program(66, data, 0),"data":data,"loc":{"start":{"line":133,"column":12},"end":{"line":145,"column":19}}})) != null ? stack1 : "")
    + "        </li>\n";
},"59":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <a tabindex=\"0\" class=\"mention_user\">\n                <i class=\"fa fa-at\" aria-hidden=\"true\"></i>\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(depth0,"is_bot"),{"name":"if","hash":{},"fn":container.program(60, data, 0),"inverse":container.program(62, data, 0),"data":data,"loc":{"start":{"line":136,"column":16},"end":{"line":136,"column":104}}})) != null ? stack1 : "")
    + "\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(depth0,"is_sender_popover"),{"name":"if","hash":{},"fn":container.program(64, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":137,"column":16},"end":{"line":137,"column":84}}})) != null ? stack1 : "")
    + "\n            </a>\n";
},"60":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"Reply mentioning bot",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":136,"column":30},"end":{"line":136,"column":59}}}));
},"62":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"Reply mentioning user",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":136,"column":67},"end":{"line":136,"column":97}}}));
},"64":function(container,depth0,helpers,partials,data) {
    return "<span class=\"hotkey-hint\">(@)</span>";
},"66":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <a tabindex=\"0\" class=\"copy_mention_syntax\" data-clipboard-text=\""
    + alias1(container.lambda(container.strict(depth0, "user_mention_syntax", {"start":{"line":140,"column":80},"end":{"line":140,"column":99}} ), depth0))
    + "\">\n                <i class=\"fa fa-at\" aria-hidden=\"true\"></i>\n                "
    + alias1(lookupProperty(helpers,"t").call(alias2,"Copy mention syntax",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":142,"column":16},"end":{"line":142,"column":44}}}))
    + "\n                "
    + ((stack1 = lookupProperty(helpers,"if").call(alias2,lookupProperty(depth0,"is_sender_popover"),{"name":"if","hash":{},"fn":container.program(64, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":143,"column":16},"end":{"line":143,"column":84}}})) != null ? stack1 : "")
    + "\n            </a>\n";
},"68":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <li>\n            <a href=\"/#settings/profile\">\n                <i class=\"fa fa-edit\" aria-hidden=\"true\"></i> "
    + container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"Edit your profile",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":151,"column":62},"end":{"line":151,"column":88}}}))
    + "\n            </a>\n        </li>\n";
},"70":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    "
    + container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"View messages with yourself",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":160,"column":20},"end":{"line":160,"column":56}}}))
    + "\n";
},"72":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    "
    + container.escapeExpression(lookupProperty(helpers,"t").call(depth0 != null ? depth0 : (container.nullContext || {}),"View direct messages",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":162,"column":20},"end":{"line":162,"column":49}}}))
    + "\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.strict, alias2=container.lambda, alias3=container.escapeExpression, alias4=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<ul class=\"nav nav-list info_popover_actions\" id=\"user_info_popover\" data-user-id=\""
    + alias3(alias2(alias1(depth0, "user_id", {"start":{"line":2,"column":85},"end":{"line":2,"column":92}} ), depth0))
    + "\">\n    <li class=\"popover_user_name_row\">\n        <b class=\"user_full_name\" data-tippy-content=\""
    + alias3(alias2(alias1(depth0, "user_full_name", {"start":{"line":4,"column":56},"end":{"line":4,"column":70}} ), depth0))
    + "\">"
    + alias3(alias2(alias1(depth0, "user_full_name", {"start":{"line":4,"column":76},"end":{"line":4,"column":90}} ), depth0))
    + "</b>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias4,lookupProperty(depth0,"is_active"),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":8},"end":{"line":11,"column":15}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias4,lookupProperty(depth0,"show_manage_menu"),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":8},"end":{"line":18,"column":15}}})) != null ? stack1 : "")
    + "    </li>\n\n\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias4,lookupProperty(depth0,"is_active"),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(11, data, 0),"data":data,"loc":{"start":{"line":22,"column":4},"end":{"line":34,"column":11}}})) != null ? stack1 : "")
    + "\n\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias4,lookupProperty(depth0,"is_bot"),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.program(24, data, 0),"data":data,"loc":{"start":{"line":37,"column":4},"end":{"line":51,"column":11}}})) != null ? stack1 : "")
    + "    "
    + ((stack1 = container.invokePartial(require("./user_custom_profile_fields.hbs"),depth0,{"name":"user_custom_profile_fields","hash":{"for_user_info_popover":true,"profile_fields":lookupProperty(depth0,"display_profile_fields")},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\n    <li class=\"only-visible-for-spectators\">"
    + alias3(lookupProperty(helpers,"t").call(alias4,"Joined {date_joined}",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":55,"column":44},"end":{"line":55,"column":73}}}))
    + "</li>\n\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias4,lookupProperty(helpers,"or").call(alias4,lookupProperty(helpers,"and").call(alias4,lookupProperty(depth0,"user_time"),lookupProperty(depth0,"is_active"),{"name":"and","hash":{},"data":data,"loc":{"start":{"line":57,"column":14},"end":{"line":57,"column":39}}}),lookupProperty(depth0,"is_me"),lookupProperty(depth0,"status_content_available"),{"name":"or","hash":{},"data":data,"loc":{"start":{"line":57,"column":10},"end":{"line":57,"column":71}}}),{"name":"if","hash":{},"fn":container.program(26, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":57,"column":4},"end":{"line":59,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias4,lookupProperty(helpers,"and").call(alias4,lookupProperty(depth0,"user_time"),lookupProperty(depth0,"is_active"),{"name":"and","hash":{},"data":data,"loc":{"start":{"line":60,"column":10},"end":{"line":60,"column":35}}}),{"name":"if","hash":{},"fn":container.program(28, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":60,"column":4},"end":{"line":62,"column":11}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias4,lookupProperty(depth0,"status_content_available"),{"name":"if","hash":{},"fn":container.program(30, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":64,"column":4},"end":{"line":84,"column":11}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias4,lookupProperty(depth0,"is_me"),{"name":"if","hash":{},"fn":container.program(41, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":86,"column":4},"end":{"line":110,"column":11}}})) != null ? stack1 : "")
    + "\n\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias4,lookupProperty(depth0,"spectator_view"),{"name":"unless","hash":{},"fn":container.program(50, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":113,"column":4},"end":{"line":171,"column":15}}})) != null ? stack1 : "")
    + "</ul>\n";
},"usePartial":true,"useData":true});